import ProbaWorkflowsSidebar from '@/components/probaworkflows_base_components/ProbaWorklfowsSidebar/ProbaWorkflowsSidebar.vue';
import navbar from "@/components/probaworkflows_base_components/Navbar/NavBar.vue";

export default {
  name: 'ProbaWorkflowsLayout',
  components: {
    ProbaWorkflowsSidebar,
    navbar
  },
  data: () => ({
    is_sidebar_hidden: false,
    show_backdrop: false,
    show_mobile_drawer: false,
    isLargeScreen: window.innerWidth >= 1200
  }),

  computed: {
    // Computed property that reacts to route changes
    should_hide_sidebar() {
      return this.$route.name === 'entity_overview'  || this.$route.name === 'entity_enquiry_management';
    }
  },

  mounted() {
    window.addEventListener("resize", this.checkScreenSize);
    // Set initial sidebar state based on route
    this.is_sidebar_hidden = this.should_hide_sidebar;
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  },

  watch: {
    // Watch computed property instead of $route directly
    should_hide_sidebar(new_val) {
      this.is_sidebar_hidden = new_val;
    },
    '$route'() {
      this.show_mobile_drawer = false;
    }
  },

  methods: {
    toggle_sidebar() {
      if (this.should_hide_sidebar) return; // ← add this
      if (window.innerWidth < 768) {
        this.show_mobile_drawer = !this.show_mobile_drawer;
      } else {
        this.is_sidebar_hidden = !this.is_sidebar_hidden;
        this.show_backdrop = !this.is_sidebar_hidden;
      }
    },
    checkScreenSize() {
      this.isLargeScreen = window.innerWidth >= 1200;
      if (this.isLargeScreen) this.show_mobile_drawer = false;
    }
  }
}